import { render, staticRenderFns } from "./panel-cart-settings.vue?vue&type=template&id=502bd82e&"
import script from "./panel-cart-settings.vue?vue&type=script&lang=js&"
export * from "./panel-cart-settings.vue?vue&type=script&lang=js&"
import style0 from "./panel-cart-settings.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports